import React from 'react';
import A2UIRenderer from './A2UIRenderer';

/**
 * WidgetBlocks Component
 * Uses A2UI renderer - only supports A2UI widgets format
 * 
 * A2UI format: { widgets: [...] } or widgets array
 */
const WidgetBlocks = ({ widgets, onEvent, className }) => {
  return (
    <div className={`widget-blocks ${className || ''}`}>
      <A2UIRenderer 
        widgets={widgets} 
        onEvent={onEvent}
        className="widget-blocks-renderer"
      />
    </div>
  );
};

export default WidgetBlocks;


